import { createElement, memo } from '@max/max';
import View from '@hfe/max-view';
import Image from '@hfe/max-image';
import Text from '@hfe/max-text';
import { getImageUrl } from '../../../lib/utils/imageUtils';
import './index.scss';
const Recommend2 = (props) => {
    var _a;
    const week = {
        Monday: '周一',
        Tuesday: '周二',
        Wednesday: '周三',
        Thursday: '周四',
        Friday: '周五',
        Saturday: '周六',
        Sunday: '周日'
    };
    console.log(props.city.week);
    return <View className='price-logo' onClick={() => props.jump(props.city, props.index)}>
      <Image x-if={props.cornerLabelImg} className="label-img" source={{
        uri: getImageUrl((_a = props.cornerLabelImg) !== null && _a !== void 0 ? _a : '', 57, 0)
    }}/>
      <Text x-if={!props.cornerLabelImg && props.cornerLabelWord} className="recommend2-label-word" style={{
        backgroundColor: props.cornerLabelBgColor,
        color: props.cornerLabelColor
    }}>
        {props.cornerLabelWord}
      </Text>
      <Image className="price-img" source={{
        uri: getImageUrl(props.city.picurl, 344, 0)
    }}/>
      <View className="price-info">
        <Text className="left-content">
          {props.city.departCityName + '-' + props.city.arriveCityName}
        </Text>
        <Text className="right-content price">
          ￥<Text className="num">{props.city.price}</Text>
        </Text>
      </View>
      <View className="price-info" style={{
        marginTop: '0'
    }}>
        <Text className="left-content font-grey">
          {props.city.date.substr(5) + ' ' + week[props.city.week]}
        </Text>
        <Text className="right-content font-grey">
          {props.city.discout > 0 ? `${props.city.discout / 10}折` : ''}
        </Text>
      </View>
    </View>;
};
export default memo(Recommend2);
